import styled from 'styled-components';

const Caption3 = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #2f3d48;
`;

export default Caption3;
